import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';
import { useState } from '@wordpress/element';
import { borderStyle, borderRadiusStyle, boxShadow, dimensions, background} from "@vayu-blocks/global";
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import { omitBy } from 'lodash';

export default function AdvanceSettings({ children, attributes,setAttributes }) {
    const [isHovered, setIsHovered] = useState(false);

    const getView = VayuBlocksDevice();

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    const styles = {
        display: 'flex',
        ...borderStyle(attributes.layoutborder, getView),
        ...borderRadiusStyle(attributes.layoutradius, getView),
        ...boxShadow(attributes.layoutShadow, getView),
        ...(attributes.layoutmargin && { margin: dimensions(attributes.layoutmargin, getView) }),
        ...(attributes.globalbg ? background(attributes.advBackground) : background(attributes.gbadvBackground)),
    };

    const hoverStyles = {
        ...(attributes.globalbg ? background(attributes.advBackgroundHover, true) : background(attributes.gbadvBackgroundHover, true)),
    };

    const filteredHoverStyles = omitBy(hoverStyles, value => !value);

    const contentstyle = attributes.globalcontent
    ? {
        '--box-color-timeline': attributes.gbboxcolor,
        '--box-hover-color-timeline': attributes.gbboxhvrcolor,
    }
    : {};

    const iconstyle = attributes.iconglobal
    ? {
        '--icon-backgoruond-color': attributes.gbiconcolor,
        '--icon-icon-color-fill-mode': attributes.gbiconiconcolor,
    }
    : {};

    const datestyle = attributes.globaldate
    ? {
        '--box-date-color': attributes.gbdatecolor,
        '--box-date-hover-color': attributes.gbdatehvrcolor,
    }
    : {};

    const mergedStyles = {
        ...styles,
        ...(isHovered ? filteredHoverStyles : {}),
        ...contentstyle,
        ...datestyle,
        ...iconstyle,
    };

    const blockProps = useBlockProps({
        style: {
            ...mergedStyles,
            '--vayu-blockls-layout-horizontal-width':attributes.widthdimension,
        },

        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
    });

    if(attributes.classNamemain !== blockProps.className) {
        setAttributes({classNamemain: blockProps.className});
    }

    return (
        <div {...blockProps}>
            {children}
        </div>
    );
}